import { Sparkline } from "./Sparkline";

interface Props {
  label: string;
  value: number | string;
  unit?: string;
  delta?: number;
  hint?: string;
  sparkline?: number[];
}

export function KpiCard({
  label,
  value,
  unit,
  delta,
  hint,
  sparkline,
}: Props) {
  return (
    <div className="bbc-kpi">
      <div className="bbc-kpi-label">{label}</div>
      <div className="bbc-kpi-value">
        <span className="num">{value}</span>
        {unit && <span className="unit">{unit}</span>}
      </div>
      <div className="bbc-kpi-meta">
        {delta != null && (
          <span className={`bbc-delta ${delta >= 0 ? "up" : "down"}`}>
            {delta >= 0 ? "▲" : "▼"} {Math.abs(delta)}%
          </span>
        )}
        {hint && <span className="bbc-kpi-hint">{hint}</span>}
      </div>
      {sparkline && <Sparkline points={sparkline} />}
    </div>
  );
}
